module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/home-property-pin-73fe6fe49f8308f40891334a9241d89e.png";